import { Component, OnInit } from '@angular/core';
import { DAO } from '../../modal/DAO'
import { AppConfig } from 'src/app/app.config';

@Component({
    selector: 'endorsementComponent',
    templateUrl: './endorsement.html'
})
export class endorsementComponent  implements OnInit {

  constructor(public dao: DAO, public appConfig: AppConfig) {}
        

    ngOnInit(): void {
        this.dao.PolicySubTemplate = 'endorsement';
       
    }
}
